import React, { useState, useEffect, useRef } from "react";
import { alpha, makeStyles } from "@material-ui/core/styles";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import IconButton from "@material-ui/core/IconButton";
import Typography from "@material-ui/core/Typography";
import Badge from "@material-ui/core/Badge";
import MenuItem from "@material-ui/core/MenuItem";
import Menu from "@material-ui/core/Menu";
import AccountCircle from "@material-ui/icons/AccountCircle";
import AccountCircleOutlinedIcon from "@material-ui/icons/AccountCircleOutlined";
import MenuIcon from "@material-ui/icons/Menu";

import MailIcon from "@material-ui/icons/Mail";
import NotificationsIcon from "@material-ui/icons/Notifications";
import MoreIcon from "@material-ui/icons/MoreVert";
// import Logo from "../assets/logo.png";
// import Logo from '../assets/aparticon.png'
import Logo from "../assets/favicons.ico";
import { Link, useHistory, useLocation } from "react-router-dom";
import Breadcrumbs from "@material-ui/core/Breadcrumbs";
import getBreadCrum from "../utils/stateParent";
import {
  Paper,
  Button,
  Grid,
  TextField,
  Input,
  hexToRgb,
} from "@material-ui/core";
import VpnKeyOutlinedIcon from "@material-ui/icons/VpnKeyOutlined";
import http from "../services/httpService";
import LogoutIcon from "@mui/icons-material/Logout";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import Draggable from "react-draggable";
import Visibility from "@material-ui/icons/Visibility";
import VisibilityOff from "@material-ui/icons/VisibilityOff";
import InputAdornment from "@material-ui/core/InputAdornment";
import toast, { Toaster } from "react-hot-toast";
import staticFiles from "../services/staticApi";
import {
  myPerformancePath,
  searchFilter,
  handleSort,
} from "../utils/varialbles";
function PaperComponent(props) {
  return (
    <Draggable
      handle="#draggable-dialog-title"
      cancel={'[class*="MuiDialogContent-root"]'}
    >
      <Paper {...props} />
    </Draggable>
  );
}
function PaperComponentImage(props) {
  return (
    <Draggable
      handle="#draggable-dialog-titleImage"
      cancel={'[class*="MuiDialogContent-root"]'}
    >
      <Paper {...props} />
    </Draggable>
  );
}
function PaperComponentBrowseImage(props) {
  return (
    <Draggable
      handle="#draggable-dialog-titleBrowseImage"
      cancel={'[class*="MuiDialogContent-root"]'}
    >
      <Paper {...props} />
    </Draggable>
  );
}
const useStyles = makeStyles((theme) => ({
  grow: {
    flexGrow: 1,
  },
  menuButton: {
    marginRight: theme.spacing(2),
  },
  title: {
    display: "block",
    color: "#3f51b5",
  },
  inputRoot: {
    color: "inherit",
  },
  inputInput: {
    padding: theme.spacing(1, 1, 1, 0),
    // vertical padding + font size from searchIcon
    paddingLeft: `calc(1em + ${theme.spacing(4)}px)`,
    transition: theme.transitions.create("width"),
    width: "100%",
    [theme.breakpoints.up("md")]: {
      width: "20ch",
    },
  },
  sectionDesktop: {
    display: "none",
    [theme.breakpoints.up("md")]: {
      display: "flex",
    },
  },
  sectionMobile: {
    display: "flex",
    [theme.breakpoints.up("md")]: {
      display: "none",
    },
  },
  appBar: {
    zIndex: theme.zIndex.drawer + 1,
  },
}));

function MenuBar({ toggleDrawer }) {
  const form = {
    current_password: "",
    set_password: "",
    confirm_password: "",
  };
  let employee_name = localStorage.getItem("empName")
    ? localStorage.getItem("empName")
    : "Admin";
  const classes = useStyles();
  const history = useHistory();
  const location = useLocation();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [profile, setPofile] = useState({});
  const [mobileMoreAnchorEl, setMobileMoreAnchorEl] = React.useState(null);
  const isMenuOpen = Boolean(anchorEl);
  const isMobileMenuOpen = Boolean(mobileMoreAnchorEl);
  const [open, setOpen] = useState(false);
  const [openImage, setopenImage] = useState(false);
  const [openBrowseImage, setopenBrowseImage] = useState(false);
  const [showCurrentPassword, setshowCurrentPassword] = React.useState(false);
  const [showSetPassword, setshowSetPassword] = React.useState(false);
  const [passwordProfle, setPassworProfile] = React.useState(form);
  const fileInputRef = useRef(null);
  const [showTitle, setShowTitle] = useState(false);
  const [proofSrc, setProofSrc] = React.useState({});

  const handleClose = () => {
    setOpen(false);
  };
  const handleImageClose = () => {
    setopenImage(false);
  };
  const handleBrowseImageClose = () => {
    setopenBrowseImage(false);
  };
  const handleChangePassword = (e) => {
    setOpen(true);
  };
  const handleChange = (e, field) => {
    setPassworProfile({ ...passwordProfle, [field]: e.target.value });
  };
  const handleImageUpload = (e) => {
    e.preventDefault();
    setopenImage(true);
  };
  const openBrowseImageDialug = (e) => {
    e.preventDefault();
    setopenImage(false);
    setopenBrowseImage(true);
  };
  const removePicture = (e) => {
    e.preventDefault();
    const formData = new FormData();
    formData.append("profile_pic", "");
    http
      .patch("/profilepic", formData)
      .then((res) => {
        if (res.data && res.data.Data && res.data.statusCode === 0) {
          toast.success(res.data.Data);
          getProfile();
          setopenImage(false);
        } else if (res.data && res.data.Data && res.data.statusCode !== 0) {
          toast.error(res.data.Data);
        } else {
          toast.error("Someting went Wrong..!");
        }
      })
      .catch((err) => {});
  };
  const SubmitPassword = (e) => {
    http
      .post("/passwordmanager", passwordProfle)
      .then((res) => {
        if (res.data && res.data.Data && res.data.statusCode === 0) {
          setPassworProfile(form);
          setOpen(false);

          toast.success(res.data.Data);
        } else if (res.data && res.data.Data && res.data.statusCode !== 0) {
          toast.error(res.data.Data);
        } else {
          toast.error("Someting went Wrong..!");
        }
      })
      .catch((err) => {});
  };
  const handleClickShowCurrentPassword = () => {
    setshowCurrentPassword(!showCurrentPassword);
  };
  const handleClickshowSetPassword = () => {
    setshowSetPassword(!showSetPassword);
  };
  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };
  const handleProfileMenuOpen = (event) => {
    let currentTarget = event.currentTarget;
    setAnchorEl(currentTarget);
  };
  useEffect(() => {
    getProfile();
    if (window.screen.width > 760) {
      setShowTitle(true);
    }
  }, []);
  const getProfile = () => {
    http
      .get("/profile_details")
      .then((result) => {
        if (
          result &&
          result.data &&
          result.data["Profile details"] &&
          Array.isArray(result.data["Profile details"]) &&
          result.data["Profile details"].length > 0
        ) {
          setPofile(result.data["Profile details"][0]);
          localStorage.getItem("empRole") && localStorage.removeItem("empRole");
          localStorage.setItem(
            "empRole",
            result.data["Profile details"][0].empdept
          );

          localStorage.setItem(
            "empMail",
            result.data["Profile details"][0].empemail
          );
        }
      })
      .catch((error) => {
        console.log("error");
      });
  };

  const handleMobileMenuClose = () => {
    setMobileMoreAnchorEl(null);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    handleMobileMenuClose();
  };

  const handleMobileMenuOpen = (event) => {
    setMobileMoreAnchorEl(event.currentTarget);
  };
  const handleFileUpload = (event) => {
    event.preventDefault();
    let formData = new FormData();
    formData.append(
      "profile_pic",
      event.target.files[0],
      event.target.files[0].name
    );
    http
      .patch("/profilepic", formData)
      .then((res) => {
        if (res.data && res.data.Data && res.data.statusCode === 0) {
          toast.success(res.data.Data);
          getProfile();
          handleBrowseImageClose();
        } else if (res.data && res.data.Data && res.data.statusCode !== 0) {
          toast.error(res.data.Data);
        } else {
          toast.error("Someting went Wrong..!");
        }
      })
      .catch((err) => {});
  };
  const logOut = (event) => {
    localStorage.setItem("logOut", true);
    history.push("/");
  };
  const viewFullProfile = (e) => {
    e.preventDefault();
    handleMenuClose();
    if (location.pathname !== myPerformancePath) {
      history.push({ pathname: myPerformancePath, state: profile });
    }
  };

  const [viewNotifs, setViewNotifs] = useState(false);
  // const templateNotifications = [
  //   {
  //     title: 'Notification header',
  //     desc: 'Notification content lorem ipsum dolor sit amet ipsum konet leisur. Corsoir do wen do.',
  //   },
  //   {
  //     title: 'Notification 2',
  //     desc: 'Notification content lorem ipsum dolor sit amet ipsum konet leisur. dolor sit amet, Corsoir do wen do.',
  //   },
  //   {
  //     title: 'Notification 3',
  //     desc: 'Notification content lorem ipsum dolor sit. dolor sit amet, Corsoir do wen do.',
  //   },

  //   {
  //     title: 'Notification 4',
  //     desc: 'Notification content lorem ipsum dolor sit. dolor sit amet, Corsoir do wen do.',
  //   },

  //   {
  //     title: 'Notification 5',
  //     desc: 'Notification content lorem ipsum dolor sit. dolor sit amet, Corsoir do wen do.',
  //   },

  //   {
  //     title: 'Notification 6',
  //     desc: 'Notification content lorem ipsum dolor sit. dolor sit amet, Corsoir do wen do.',
  //   },

  //   {
  //     title: 'Notification 7',
  //     desc: 'Notification content lorem ipsum dolor sit. dolor sit amet, Corsoir do wen do.',
  //   },
  // ];
  const [userNotifications, setUserNotifications] = useState([]);
  const [notifReadStatus, setNotifReadStatus] = useState(true);
  const handleNotificationBrowser = (e) => {
    setViewNotifs((x) => !x);
    //updatenotifications/[id]
    setNotifReadStatus(true);
    userNotifications.map((notif) => {
      if (!notif.read) {
        http.patch(`/updatenotifications/${notif.id}/`);
        // ('sent', notif.id)
      }
    });
  };

  //fetch notifications
  const fetchNotifications = () => {
    http.get("/notificationslist").then((res) => {
      // (res);
      //write the line to feed the fetched notifications
      if (res.data && res.data.Data && res.data.statusCode === 0) {
        setUserNotifications(res.data.Data);
        if (res.data.Unread) {
          setNotifReadStatus(false);
        }
      }
    });
  };
  const notificationsFetchInterval = 30; // seconds
  useEffect((x) => {
    fetchNotifications();
    setInterval(() => {
      //fetchNotifications()
    }, notificationsFetchInterval * 1000);
    // fetchNotifications();
  }, []);

  const menuId = "primary-search-account-menu";
  const renderMenu = (
    <Menu
      anchorEl={anchorEl}
      id={menuId}
      keepMounted
      open={isMenuOpen}
      onClose={handleMenuClose}
      getContentAnchorEl={null}
      transformOrigin={{ horizontal: "center", vertical: "bottom" }}
      anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
      style={{ top: "50px", paddingTop: 0, paddingBottom: 0 }}
    >
      <div className="menupopup">
        <div style={{ height: "60%" }}>
          <div style={{ textAlign: "center" }}>
            <IconButton onClick={handleImageUpload}>
              {profile && profile.profile_pic && profile.profile_pic !== "" ? (
                <img
                  src={staticFiles + profile.profile_pic}
                  style={{
                    width: 100,
                    height: 100,
                    borderRadius: "50%",
                  }}
                ></img>
              ) : (
                <AccountCircleOutlinedIcon
                  style={{
                    width: 100,
                    height: 100,
                    color: "gray",
                  }}
                />
              )}
            </IconButton>
          </div>
          <div
            style={{ textAlign: "center", marginTop: "5px", fontWeight: "600" }}
          >
            {profile.empfname + " " + profile.emplname}
          </div>
          <div
            style={{ textAlign: "center", marginTop: "5px", color: "#8B94B4" }}
          >
            {profile.empemail}
          </div>
          <div
            style={{ textAlign: "center", marginTop: "5px", fontWeight: "600" }}
          >
            Role : {profile.empdept}
          </div>
        </div>
        <div style={{ textAlign: "center" }}>
          <Link
            style={{ color: "#2856F0", fontWeight: 400, opacity: 1 }}
            onClick={viewFullProfile}
          >
            View Full Profile
          </Link>
        </div>
        {/* 
        <div style=
          marginTop: "20px",
          left: "1509px",
          width: "375px",
          height: "45px",
          background: "#ffffff 0% 0% no-repeat padding-box",
          borderTop: "0.1px solid #707070",
          borderBottom: "0.1px solid #707070",
          borderLeft: "0px",
          borderRight: "0px",
          font: "normal normal normal 18px/24px Roboto",
          textAlign: "left",
          paddingLeft: "30px",

          opacity: 1,
          cursor: "pointer"
        }}
          onClick={handleChangePassword}
        ><VpnKeyOutlinedIcon style={{ paddingTop: "5px", width: 30, height: 30 }} />
          <span> Password Manager</span>
        </div> */}
        <div className={"passwordparent"}>
          <div className={"passwordChange"} onClick={handleChangePassword}>
            <VpnKeyOutlinedIcon
              style={{ paddingTop: "5px", width: 30, height: 30 }}
            />
            <span style={{ lineHeight: "40px", display: "inline-block" }}>
              {" "}
              Password Manager
            </span>
          </div>
          <div className={"passwordChange"} onClick={logOut}>
            <LogoutIcon style={{ paddingTop: "5px", width: 30, height: 30 }} />
            <span style={{ lineHeight: "35px", display: "inline-block" }}>
              {" "}
              Logout
            </span>
          </div>
        </div>
      </div>
    </Menu>
  );

  const mobileMenuId = "primary-search-account-menu-mobile";
  const renderMobileMenu = (
    <Menu
      anchorEl={mobileMoreAnchorEl}
      id={mobileMenuId}
      keepMounted
      open={isMobileMenuOpen}
      onClose={handleMobileMenuClose}
      transformOrigin={{ horizontal: "right", vertical: "bottom" }}
      anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
      style={{
        top: "90px",
        left: "1509px",
        width: "375px",
        height: "382px",
        background: "#F5F5F5 0% 0% no-repeat padding-box",
        boxShadow: "0px 2px 2px #00000029",
        border: "0.10000000149011612px solid #707070",
        opacity: "1",
      }}
    >
      {/* <MenuItem>
        <IconButton aria-label="show 4 new mails" color="inherit">
          <Badge badgeContent={4} color="secondary">
            <MailIcon />
          </Badge>
        </IconButton>
        <p>Messages</p>
      </MenuItem> */}
      <MenuItem>
        <IconButton aria-label="show 11 new notifications" color="inherit">
          <Badge badgeContent={9} color="secondary">
            <NotificationsIcon />
          </Badge>
        </IconButton>
        Notifications
      </MenuItem>
      <MenuItem onClick={handleProfileMenuOpen}>
        <IconButton
          aria-label="account of current user"
          aria-controls="primary-search-account-menu"
          aria-haspopup="true"
          color="inherit"
        >
          <AccountCircle />
        </IconButton>
        Profile
      </MenuItem>
    </Menu>
  );

  return (
    <div className={classes.grow}>
      <AppBar position="fixed" color="inherit" className={classes.appBar}>
        <Toolbar>
          <div>
            <IconButton
              aria-label="show more"
              aria-controls={mobileMenuId}
              aria-haspopup="true"
              onClick={toggleDrawer}
              color="inherit"
            >
              <MenuIcon />
            </IconButton>
          </div>
          <Typography
            className={classes.title}
            variant="h6"
            noWrap
            style={{ marginBottom: 5, paddingRight: 10 }}
          >
            <img src={Logo} alt="savart Logo" className="svrtlogo" />{" "}
            {showTitle ? "APART" : ""}
          </Typography>
          <Typography
            color="textPrimary"
            variant="h6"
            noWrap
            className="breadcrum"
          >
            {getBreadCrum(location.pathname)}
          </Typography>
          <div className={classes.grow} />
          <div className={classes.sectionDesktop}>
            {/* <IconButton aria-label="show 4 new mails" color="default">
              <Badge badgeContent={4} color="primary">
                <MailIcon />
              </Badge>
            </IconButton> */}
            <IconButton
              aria-label="show 17 new notifications"
              color="default"
              onClick={handleNotificationBrowser}
            >
              <Badge
                badgeContent={notifReadStatus && 0}
                variant={"dot"}
                color="primary"
              >
                <NotificationsIcon />
              </Badge>
              {viewNotifs && (
                <div className="notif-screen">
                  <div className="notif-screen-background"></div>
                  <div
                    className="notif-screen-content"
                    onClick={(x) => x.stopPropagation()}
                  >
                    {userNotifications.map((notif, index) => {
                      return (
                        <div className="ns-notif" key={index}>
                          <div className="ns-notif-header">{notif.subject}</div>
                          <div className="ns-notif-desc">
                            {notif.notification}
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </div>
              )}
            </IconButton>
            <IconButton
              edge="start"
              size="medium"
              aria-label="account of current user"
              aria-controls={menuId}
              aria-haspopup="true"
              onClick={handleProfileMenuOpen}
              color="default"
            >
              {profile && profile.profile_pic && profile.profile_pic !== "" ? (
                <img
                  src={staticFiles + profile.profile_pic}
                  style={{
                    width: 30,
                    height: 30,
                    borderRadius: "50%",
                  }}
                ></img>
              ) : (
                <AccountCircle />
              )}
            </IconButton>
            <span style={{ marginTop: 15, marginBottom: 10 }}>
              Welcome {employee_name}
            </span>
          </div>
          <div className={classes.sectionMobile}>
            <IconButton
              aria-label="show more"
              aria-controls={menuId}
              aria-haspopup="true"
              onClick={handleProfileMenuOpen}
              color="inherit"
            >
              <MoreIcon />
            </IconButton>
          </div>
        </Toolbar>
      </AppBar>
      {renderMobileMenu}
      {renderMenu}
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="draggable-dialog-title"
        maxWidth="sm"
        fullWidth
        PaperComponent={PaperComponent}
      >
        <DialogTitle
          style={{ cursor: "move", textAlign: "center" }}
          id="draggable-dialog-title"
        >
          Password Manager
        </DialogTitle>
        <DialogContent>
          <Grid container style={{ marginTop: 30 }}>
            <Grid item xs={12} sm={5}>
              <Typography variant={"body1"}>Current Password</Typography>
            </Grid>
            <Grid item xs={12} sm={6}>
              <Typography variant={"body1"}>
                <Input
                  id="standard-adornment-password"
                  variant="outlined"
                  margin="none"
                  required
                  fullWidth
                  type={showCurrentPassword ? "text" : "password"}
                  placeholder="password"
                  value={passwordProfle.current_password}
                  name="current_password"
                  onChange={(e) => handleChange(e, "current_password")}
                  endAdornment={
                    <InputAdornment position="end">
                      <IconButton
                        aria-label="toggle password visibility"
                        onClick={handleClickShowCurrentPassword}
                        onMouseDown={handleMouseDownPassword}
                      >
                        {showCurrentPassword ? (
                          <Visibility />
                        ) : (
                          <VisibilityOff />
                        )}
                      </IconButton>
                    </InputAdornment>
                  }
                />
              </Typography>
            </Grid>
          </Grid>
          <Grid container style={{ marginTop: 30 }}>
            <Grid item xs={12} sm={5}>
              <Typography variant={"body1"}>Set Password</Typography>
            </Grid>
            <Grid item xs={12} sm={6}>
              <Typography variant={"body1"}>
                <Input
                  id="standard-adornment-password"
                  variant="outlined"
                  margin="none"
                  required
                  fullWidth
                  type={showSetPassword ? "text" : "password"}
                  placeholder="password"
                  value={passwordProfle.set_password}
                  onChange={(e) => handleChange(e, "set_password")}
                  endAdornment={
                    <InputAdornment position="end">
                      <IconButton
                        aria-label="toggle password visibility"
                        onClick={handleClickshowSetPassword}
                        onMouseDown={handleMouseDownPassword}
                      >
                        {showSetPassword ? <Visibility /> : <VisibilityOff />}
                      </IconButton>
                    </InputAdornment>
                  }
                />
              </Typography>
            </Grid>
          </Grid>
          <Grid container style={{ marginTop: 30 }}>
            <Grid item xs={12} sm={5}>
              <Typography variant={"body1"}>Confirm Password</Typography>
            </Grid>
            <Grid item xs={12} sm={6}>
              <Typography variant={"body1"}>
                <Input
                  id="standard-adornment-password"
                  variant="outlined"
                  margin="none"
                  required
                  fullWidth
                  placeholder="password"
                  type={"password"}
                  value={passwordProfle.confirm_password}
                  onChange={(e) => handleChange(e, "confirm_password")}
                />
              </Typography>
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions
          style={{
            display: "flex",
            justifyContent: "center",
            paddingBottom: 30,
          }}
        >
          <Button
            onClick={handleClose}
            variant="contained"
            style={{ paddingLeft: 30, paddingRight: 30 }}
          >
            Cancel
          </Button>
          <Button
            onClick={(e) => SubmitPassword()}
            variant="contained"
            color="primary"
            style={{ paddingLeft: 30, paddingRight: 30 }}
          >
            Save
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={openImage}
        onClose={handleImageClose}
        PaperComponent={PaperComponentImage}
        aria-labelledby="draggable-dialog-titleImage"
        maxWidth="xs"
      >
        <DialogTitle
          style={{ cursor: "move" }}
          id="draggable-dialog-titleImage"
        ></DialogTitle>
        <DialogContent style={{ paddingBottom: 30 }}>
          <Grid container>
            <Grid item xs={12} align="center">
              <Button
                onClick={openBrowseImageDialug}
                variant="contained"
                color="primary"
              >
                Change Picture
              </Button>
            </Grid>
            <Grid
              item
              xs={12}
              align="center"
              style={{ marginTop: 30, marginBottom: 30 }}
            >
              <Typography variant="h6">Or</Typography>
            </Grid>
            <Grid item xs={12} align="center">
              <Button
                onClick={removePicture}
                variant="outlined"
                color="primary"
              >
                Remove Picture
              </Button>
            </Grid>
          </Grid>
        </DialogContent>
      </Dialog>
      <Dialog
        open={openBrowseImage}
        onClose={handleBrowseImageClose}
        PaperComponent={PaperComponentBrowseImage}
        aria-labelledby="draggable-dialog-titleBrowseImage"
        maxWidth="xs"
        // style={{
        //   top: "320px",
        //   left: "861px",
        //   width: "483px",
        //   height: "440px"
        // }}
      >
        <DialogTitle
          style={{ cursor: "move" }}
          id="draggable-dialog-titleBrowseImage"
        ></DialogTitle>
        <DialogContent style={{ paddingBottom: 30, width: 300, height: 200 }}>
          <Grid item xs={12} align="center" style={{ marginTop: "20%" }}>
            <input
              ref={fileInputRef}
              onChange={handleFileUpload}
              type="file"
              style={{ display: "none" }}
              multiple={false}
            />
            <Button
              onClick={() => fileInputRef.current.click()}
              variant="contained"
              color="primary"
              style={{ paddingLeft: 30, paddingRight: 30 }}
            >
              Browse
            </Button>
          </Grid>
        </DialogContent>
      </Dialog>
    </div>
  );
}
export default MenuBar;
